let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4j1rt")).then(() => parcelRequire('kMSTR'));